export const formatCurrency = (amount: { toLocaleString: (arg0: string) => unknown }) => {
  const NumberAmount = Number(amount);
  return `₹ ${NumberAmount.toLocaleString("en-IN")}`;
};

// ─── Currency helpers ─────────────────────────────────────────────────────────

export const INDIA_COUNTRY = "India";

/** Returns "INR" for Indian companies, "USD" for all others. */
export function getCurrencyForCountry(headquartersCountry?: string | null): "INR" | "USD" {
  return headquartersCountry === INDIA_COUNTRY ? "INR" : "USD";
}

/** Formats a monetary amount with the correct symbol and locale. */
export function formatPrice(amount: number, currency: "INR" | "USD"): string {
  if (currency === "INR") {
    return `₹${amount.toLocaleString("en-IN")}`;
  }
  return `$${amount.toLocaleString("en-US")}`;
}
